import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import templateHtml from 'templates/challenge/adhocChallengeGDPRModal.html';

var AdhocChallengeGDPRModalView = Backbone.View.extend({
    initialize: function(args) {
        this.template = _.template(templateHtml);
        this.isVivokidChallenge = args.isVivokidChallenge;
    },

    render: function() {
        var html = this.template({
            Localizer: Localizer,
            isVivokidChallenge: this.isVivokidChallenge || false
        });

        this.$el.html(html);
    }
});

export default AdhocChallengeGDPRModalView;
